import { z } from 'zod'
import { oc } from '@orpc/contract'
import { REFERRAL_SPECIALTY_CODES } from '../referral-specialties.schema'
import { rosterViewSchema } from './referral-discovery-views.schema'

export const referralDiscoveryRostersInputSchema = z.object({
  placeIds: z.array(z.string().min(1).max(300)).min(1).max(20),
  specialtyCode: z.enum(REFERRAL_SPECIALTY_CODES),
})

export const referralDiscoveryRosters = oc
  .route({ method: 'POST', path: '/v2/referral-discovery/rosters' })
  .input(referralDiscoveryRostersInputSchema)
  .output(z.object({ items: z.record(z.string(), rosterViewSchema) }))
